import { render, staticRenderFns } from "./performanceManagement.vue?vue&type=template&id=3834e277&scoped=true&"
import script from "./performanceManagement.vue?vue&type=script&lang=ts&"
export * from "./performanceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./performanceManagement.vue?vue&type=style&index=0&id=3834e277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834e277",
  null
  
)

export default component.exports